<div [ngClass]="{'subBlockContainer': !setFullWindow , 'subBlockContainer_full':setFullWindow} ">
  <div class="pageTitle">
    {{tittle}}
    <i class="material-icons pullfloat-right" (click)="close()">close</i>

  </div>
  <div class="subBlockContent">

    <div class="row">
      <div class="col-md-8 ">
        <div class="main-background">
          <div class="row">
            <div class="col-md-3">
              <label for=""> FIRST NAME
              </label>
            </div>
            <div class="col-md-9">
              <div class="input-group mb-3">
                <input type="text" class="form-control" placeholder="First Name">
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <label for="">LAST NAME</label>
            </div>
            <div class="col-md-9">
              <div class="input-group mb-3">
                <input type="text" class="form-control" placeholder="Last Name">
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <label for="">EMAIL</label>
            </div>
            <div class="col-md-9">
              <div class="input-group mb-3">
                <input type="text" class="form-control" placeholder="Email">
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <label for="">PHONE</label>
            </div>
            <div class="col-md-9">
              <div class="input-group mb-3">
                <input type="text" class="form-control" placeholder="phone number">
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <label for="">ACCOUNT NUMBER</label>
            </div>
            <div class="col-md-9">
              <div class="input-group mb-3">
                <input type="text" class="form-control" placeholder="account number">
              </div>

            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <label for="">TYPE OF ENQUIRY</label>

            </div>
            <div class="col-md-9">
              <div class="input-group mb-3">
                <input type="text" class="form-control" placeholder="type">
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <label for=""> COMMENTS</label>
            </div>
            <div class="col-md-9">
              <div class="input-group mb-3">
                <textarea type="text" class="form-control" placeholder="comments"></textarea>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-3">
              <button class="submit">SUBMIT</button>
            </div>
          </div>

        </div>


      </div>
      <div class="col-md-4 ">
        <button class="submit" style="margin-bottom: 20px">
          BECOME A RESELLER
        </button>
        <div class="side-background">
          Download a copy of the Dicker Data contact sheet ABN 95 000 969 362 Pick-Up/Delivery Address (9AM to 4PM) 230 Captain Cook
          Drive Kurnell, NSW 2231 Phone Contacts General Enquiries: 1800 688 586 Account Enquiries: (02) 9589 8409 Fax Number:
          1800 688 486 Hardware Sales: (02) 9589 8400 Software Sales: (02) 8556 8060 Cisco Presales: (02) 8556 8051 HPE &
          Lenovo EBG Presales: (02) 8556 8052 Microsoft Sales: (02) 8556 8061 Email Contacts Orders: orders@dickerdata.com.au
          Sales Enquiries/Quotes: sales@dickerdata.com.au Returns: ras@dickerdata.com.au Dicker Data Services: services.sales@dickerdata.com.au
          Cisco Presales: cisco.presales@dickerdata.com.au HPE & Lenovo EBG Presales: presales@dickerdata.com.au Microsoft
          Licensing: microsoft.sales@dickerdata.com.au Software Licensing: licensing@dickerdata.com.au Banking Details Westpac
          Banking Corporation BSB: 032-052 Account Number: 286 617 Swift Code: WPACAU2S BPAY Details Biller Code: 89946
        </div>

      </div>

    </div>

  </div>

  <div #entry>


  </div>
</div>
